export default {
  LOAD_MY_NOTIFICATIONS_LIST_PAGE_NOTIFICATIONS_START: 'LoadMyNotificationsListPageNotificationsStart',
  LOAD_MY_NOTIFICATIONS_LIST_PAGE_NOTIFICATIONS_END: 'LoadMyNotificationsListPageNotificationsEnd',
  UPDATE_MY_NOTIFICATIONS_LIST_PAGE_READ_NOTIFICATION_IDS: 'UpdateMyNotificationsListPageReadNotificationIds'
};